import { createReducer, on, Action } from '@ngrx/store';
import * as PackInFocusActions from './pack-in-focus.actions';
import { PackInFocusState } from './pack-in-focus.models';

export const PACK_IN_FOCUS_FEATURE_KEY = 'packInFocus';

export interface PackInFocusPartialState {
  readonly [PACK_IN_FOCUS_FEATURE_KEY]: PackInFocusState;
}

export const initialPackInFocusState: PackInFocusState = {
  data: null,
};

const reducer = createReducer(
  initialPackInFocusState,
  on(PackInFocusActions.setPackInFocus, (state, packInFocus) => {
    return {
      ...state,
      ...packInFocus,
    };
  }),
  on(PackInFocusActions.clearPackInFocus, state => {
    return {
      ...state,
      ...initialPackInFocusState,
    };
  })
);

export function packInFocusReducer(state: PackInFocusState | undefined, action: Action): PackInFocusState {
  return reducer(state, action);
}
